<svg class="icon-edit" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.06349 3.30999L5.27502 1.52153L0.954102 5.84245V7.63091H2.74256L7.06349 3.30999ZM1.90795 6.67707V6.2383L5.27502 2.87122L5.71379 3.30999L2.34672 6.67707H1.90795Z" fill="#18A0F8"/>
  <path d="M8.44639 1.92677C8.63239 1.74077 8.63239 1.44031 8.44639 1.25431L7.33039 0.138308C7.235 0.0429231 7.11577 0 6.99177 0C6.87254 0 6.74854 0.0476923 6.65793 0.138308L5.78516 1.01108L7.57362 2.79954L8.44639 1.92677Z" fill="#18A0F8"/>
  <path d="M9.53846 8.58456H0V10.4923H9.53846V8.58456Z" fill="#18A0F8"/>
</svg>

